export const compare = function (a, b) {

    var result = {
      different: [],
      missing_from_local: [],
      missing_from_remote: []
    };

    _.reduce(a, function (result, value, key) {
      if (b[key] != undefined) {
        if (_.isEqual(value, b[key])) {
          return result;
        } else {
          if (typeof (a[key]) != typeof ({}) || typeof (b[key]) != typeof ({})) {
            //dead end.
            result.different.push(key);
            return result;
          } else {
            var deeper = compare(a[key], b[key]);
            result.different = result.different.concat(_.map(deeper.different, (sub_path) => {
              return key + "." + sub_path;
            }));

            result.missing_from_remote = result.missing_from_remote.concat(_.map(deeper.missing_from_remote, (sub_path) => {
              return key + "." + sub_path;
            }));

            result.missing_from_local = result.missing_from_local.concat(_.map(deeper.missing_from_local, (sub_path) => {
              return key + "." + sub_path;
            }));
            return result;
          }
        }
      } else {
        result.missing_from_remote.push(key);
        return result;
      }
    }, result);

    _.reduce(b, function (result, value, key) {
      if (a[key] != undefined) {
        return result;
      } else {
        result.missing_from_local.push(key);
        return result;
      }
    }, result);

    return result;
  }

  // debounce helper
export const debounce = function(fn, delay) {
  console.log("debounced something")
	var timer = null;
	return function() {
		var context = this,
			args = arguments;
		clearTimeout(timer);
		timer = setTimeout(function() {
      console.log("really debounced something")
			fn.apply(context, args);
		}, delay);
	};
}


// WEBPACK FOOTER //
// ./src/helpers/index.js